import { AlertsManagerWidgetWrapper } from '../../alerts-manager-widget/AlertsManagerWidget';
import type { AlertsManagerWidgetEntity } from '../../alerts-manager-widget/AlertsManagerWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderAlertsManagerWidget(
  widget: AlertsManagerWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return () => <AlertsManagerWidgetWrapper entity={widget} options={options} />;
}
